'use client';

import { styled } from '@mui/material/styles';

export const SynchronizationInfoContainer = styled('div')(({ theme }) => ({
  maxWidth: '100%',
  marginTop: 8,
  marginBottom: 16,
  fontSize: 12,
  letterSpacing: 0.25,

  [theme.breakpoints.up('tabletLG')]: {
    marginTop: 15,
    marginBottom: 30,
  },

  '&:empty': {
    display: 'none',
  },
}));
